import type { FaireProductEntity } from "../../entity_types/product";

export const p_42jccpf3pc: FaireProductEntity = {
  token: "p_42jccpf3pc",
  type: "product",
  name: "Heart-shaped Glass Drill Gold-plated Bracelet",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/82c7b82aabc6aa8f56fddbb10cee2e469d0fe069986409c5a5e18f9af956d63f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cac8a77368efd3686604262ce92a14f3d59b9d17a5f383895615437017fb4560.jpeg",
    "https://cdn.faire.com/fastly/ea3379cef85f648a7640b6f8bb24cef895fdcfb753f23d3fd22b56f998fafb17.jpeg",
  ],
  priceDollars: 7.35,
  description:
    "\n Material: copper, glass drill \n\n Type: Bracelet \n\n Size:165mm + 60mm / 6.49 inch + 2.36 inch\n\n\n\n\n★Made of high quality material, Nickel-free / Lead-free  , Harmless to Human Body..\n\n\n\n\n★Perfect jewelry gifts\n\n\n",
  tags: [],
  msrpDollars: 14.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:21.834Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
